import React, { useEffect, useState } from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, Box, Center, Text, Image, Flex, } from "@chakra-ui/react";
import { useSelector, useDispatch } from 'react-redux';
import {generateAuthorizationCode, setQrTimeout} from '../features/authorizationSlice';
import { generateQr } from '../utils/functions';

const PortalActionsQr = ({ isOpen, onClose }) => {
  const [qrCode, setQrCode] = useState("");
  const { qrData, loading, qrTimeout, actionType } = useSelector((state) => state.authorization);
  const dispatch = useDispatch();

  useEffect(() => {
    if (qrData && qrData.length > 0) {
      generateQr(qrData).then(res => setQrCode(res));
    } else {
      setQrCode("");
    }
  }, [qrData]);
  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose} closeOnEsc={loading !== "pending"} closeOnOverlayClick={loading !== "pending"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign='center' textTransform='uppercase'>
          <div className="modal-header-image">
            {
              actionType === "EDIT_BRANCH"? (
                  <Image src="../../images/caution.png" />
              ) : (
                  <Image src="../images/caution.png" />
              )
            }
          </div>
          Access Needed
        </ModalHeader>
        {loading !== "pending" && <ModalCloseButton />}
        <ModalBody>
          <Center flexDir={"column"}>
            {loading === "pending" ? (
              <Center border='solid 1px #f1f1f1' w='232px' h='232px'>
                <Image w='40px' h='40px' src='/Images/skash_Rocket.gif' alt='Loading...' />
              </Center>
            ) : (
              <Center flexDir='column'>
                <Center bgSize='232px 232px' w='232px' h='232px' backgroundImage={qrCode}>
                  {qrTimeout && (
                    <Box
                      className='red-circle'
                      borderRadius='50%'
                      width={{ base: "200px", lg: "120px", xl: "150px", "2xl": "200px" }}
                      height={{ base: "200px", lg: "120px", xl: "150px", "2xl": "200px" }}
                      bgColor='#3682AC'
                      onClick={() => {
                          dispatch(generateAuthorizationCode());
                        }
                      }
                    >
                      <Flex direction='column' alignItems='center' justifyContent='center' w='100%' h='100%' padding={{ base: "25% 30px", lg: "0", xl: "25% 30px" }}>
                        <Image src='/Images/skash_loading.png' alt='loading' w={{ base: "33px", lg: "18px", xl: "23px", "2xl": "33px", }} h={{ base: "30px", lg: "18px", xl: "20px", "2xl": "30px", }} />
                        <Text fontSize={{ base: "15px", lg: "8px", xl: "10px", "2xl": "15px", }} textAlign='center' padding='18px' color='#fff'>CLICK TO RELOAD QR CODE</Text>
                      </Flex>
                    </Box>
                  )}
                </Center>
                <Text fontSize='12px' fontWeight='bold'>
                  Scan QR code.
                </Text>
              </Center>
            )}
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PortalActionsQr;
